import { classNames, Component, h, OmiProps, tag, VNode } from "omi";

import { tailwind } from "@/tailwind";

import styles from "./style.css?inline";

type Props = {
  label?: string;
  children?: VNode | VNode[];
  padding: "t-sm" | "t-lg" | "xs" | "sm";
  casing?: "uppercase" | "lowercase" | "capitalize" | "normal-case";
};

@tag("nw-divider")
export class NWDivider extends Component<Props> {
  static css = [tailwind, styles];

  static propTypes = {
    padding: String,
    label: String,
    casing: String,
  };

  render(props: OmiProps<Props>) {
    const hasChildren = this.childNodes.length > 0;

    return (
      <div
        class={classNames("w-full", {
          "mt-40": props.padding === "t-lg",
          "mt-10": props.padding === "t-sm",
          "my-8": props.padding === "sm",
          "my-6": props.padding === "xs",
        })}
      >
        <div class={classNames("w-full flex items-center justify-around gap-2", { "gap-0": !hasChildren })}>
          <div class="h-[1px] bg-gray-200 w-full flex-1"></div>
          {hasChildren && (
            <div class={classNames("text-sm", this.props.casing || "uppercase")}>
              <slot></slot>
            </div>
          )}
          <div class="h-[1px] bg-gray-200 w-full flex-1"></div>
        </div>
      </div>
    );
  }
}
